import { Layout } from 'components'
import React from 'react'
import 'styles/style.css'
import { GlobalProvider as ThemeProvider } from 'utils/globalContext'

// Logs when the client route changes
// export const onRouteUpdate = ({ location, prevLocation }) => {}

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return (
    <ThemeProvider>
      <Layout {...props}>{element}</Layout>
    </ThemeProvider>
  )
}
